var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { Prop, Watch } from 'vue-property-decorator';
import AreaSelection from '~/components/common/area-selection.vue';
import { OutsourceCommissionedService } from '~/services/domain-service/outsource-commissioned-manage.service';
var CommissionedDialog = /** @class */ (function (_super) {
    __extends(CommissionedDialog, _super);
    function CommissionedDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.form = {
            name: '',
            proinviceCode: '',
            cityCode: '',
            companyType: '',
            status: '',
            address: '',
            organizationType: '',
            linkMan: '',
            linkPhone: '',
            email: '',
            collectionAddress: '',
            remark: '',
            selectedCitysList: [],
            areaId: '',
            areaName: '',
            deptName: '',
        };
        _this.areaIds = [];
        return _this;
    }
    //验证
    // private rules: any = {
    //   name: [{ required: true, message: '请填写受托方' ,trigger: 'blur'}],
    //   organizationType: [{ required: true, message: '请选择机构类型', trigger: 'blur' }],
    //   status: [{ required: true, message: '请选择状态', trigger: 'blur' }],
    //   areaIds: [{ required: true, message: '请选择地区', trigger: 'blur' }],
    //   address: [{ required: true, message: '请填写具体地址', trigger: 'blur' }],
    //   linkPhone: [{ required: true, message: '请填写联系人手机号码', trigger: 'blur' }],
    //   linkMan: [{ required: true, message: '请填写联系人', trigger: 'blur' }],
    //   selectedCitysList: [{ required: true, message: '请选择催收区域', trigger: 'blur' }],
    // };
    CommissionedDialog.prototype.mounted = function () {
        this.formData();
    };
    CommissionedDialog.prototype.onCaseRowChange = function () {
        this.formData();
    };
    //数据回显
    CommissionedDialog.prototype.formData = function () {
        var _a;
        var _this = this;
        this.form = {};
        this.form.name = this.caseRow.outsName;
        this.form.organizationType = this.caseRow.outSourceType;
        this.form.status = this.caseRow.outsourceStatus;
        this.form.companyCode = this.caseRow.companyCode;
        this.form.proinviceCode = this.caseRow.areaId;
        this.form.cityCode = this.caseRow.areaId;
        this.form.address = this.caseRow.outsAddress;
        this.form.deptName = this.caseRow.deptName;
        this.form.linkMan = this.caseRow.outsContacts;
        this.form.linkPhone = this.caseRow.outsPhone;
        this.form.remark = this.caseRow.outsRemark;
        this.form.email = this.caseRow.email;
        var arr = this.$city.getCityParent(Number(this.caseRow.areaId));
        arr.push(this.caseRow.areaId);
        this.form.areaName = (_a = this.$city).getCityName.apply(_a, arr);
        //需要去掉,
        if (this.caseRow.areaCodeIds) {
            var temp = this.caseRow.areaCodeIds.split(',').filter(function (item) {
                return item;
            });
            var Ids = temp.map(function (val) { return Number(val); });
            this.form.selectedCitysList = Ids.map(function (val) {
                return {
                    value: val,
                    label: _this.$city.getCityNameById(val),
                };
            });
        }
    };
    __decorate([
        Dependencies(OutsourceCommissionedService)
    ], CommissionedDialog.prototype, "outsourceCommissionedService", void 0);
    __decorate([
        Prop({ required: true })
    ], CommissionedDialog.prototype, "caseRow", void 0);
    __decorate([
        Watch('caseRow')
    ], CommissionedDialog.prototype, "onCaseRowChange", null);
    CommissionedDialog = __decorate([
        Component({
            components: {
                AreaSelection: AreaSelection,
            },
        })
    ], CommissionedDialog);
    return CommissionedDialog;
}(Vue));
export default CommissionedDialog;
